export default __webpack_public_path__ + "static/media/Pyramide-besoins_pro_n7_spiritualite.dd3c323c.svg";